/* Defines the authority entity */
export interface Authority {
    address1?: string;
    address2?: string;
    city?: string;
    contact?: string;
    coord: Coord[];
    email?: string;
    fax?: string;
    id: any;  
    multipleLocation?: boolean;
    department: string;
    division: string;
    board: string;
    officeHours?: string;
    st: string;
    teleExt?: string;
    telephone?: string;
    url?: string;
    zip?: string;
    zipExt?: string;
    haslicenses?: boolean;
    updateddate?: Date;
  }

  export interface Coord{
    coordId?: string;
    coordName?: string;
    coordEmail?: string;
    coordPhone?: string;
    coordExt?: string;
  }
  
  export interface AuthorityResolved {
    authority: Authority;
    error?: any;
  }  

  export function newAuthority(auth): Authority{
    const a: Authority={
      address1: '',
      address2: '',
      city: '',
      contact: '',
      coord:[],   
      email: '',
      fax: '',
      id: 0,
      multipleLocation: false,
      department: '',
      division: '',
      board: '',
      officeHours: '',
      st: 'NC',
      teleExt: '',
      telephone: '',
      url: '',
      zip: '',
      zipExt: '',
      haslicenses: false
    };
    let c=newCoord(auth.isCoordinator?auth.currentUser.id:0);
    a.coord.push(c);
    console.log(a);
    return a;
  }

  export function newCoord(coordid:number=0): Coord{
    const c: Coord={
      coordId:(coordid+1000).toString().slice(1),
      coordName:'',
      coordEmail: null,
      coordPhone: '',
      coordExt: ''
    };
    return c;    
  }

  